export const FeatureFlag = {
  // add your feature flags here, the value on the right is the key defined in the LaunchDarkly dashboard for example:
  MAX_OWNED_WORKSPACES: 'max_owned_workspaces',
  WHISPER_TOOL: 'whisper-tool',
  EMPTY_TEMPLATE_UUID: 'empty-project-template-uuid',
  BING_SEARCH_ENABLED: 'show-bing-search',
  URL_PROPERTY_TOOL: 'url-property-tool',
  GO_TOOL_ENABLED: 'show-go-model',
  /**
   * If true, then the 'worker' role is available. Users can then be created as
   * workers, and updated to have this role.
   */
  WORK_ASSIGNENT: 'work-assignment',
  // When true, the user can see the AWS OCR tool
  AMAZON_TEXTRACT: 'amazon-textract-tool',
  /**
   * When true, all users will see the Intercom chat widget. When false, only
   * pro and enterprise users will see the chat widget.
   */
  INTERCOM_FOR_ALL_USERS: 'intercom-for-all-users',

  /**
   * When true, non enterprise users will see the total estimated value of the tokens for the given plan.
   */
  PLAN_TOKENS_VALUE: 'plan-tokens-value',
  /**
   * We show/hide UI elements on the frontend depending on a user's permissions in
   * the current agent/workspace. e.g. an agent 'reader' cannot create entities
   * so can't see the 'Add Entity' button.
   *
   * When enabled, the frontend will believe that the current user has every
   * permission, and so will render UI elements that will send API requests that
   * might fail.
   *
   * This flag is to be used when we want to test that the backend is correctly
   * blocking requests.
   */
  ENABLE_ALL_FRONTEND_ACTIONS: 'enable-all-frontend-actions',
  AI_MODEL_VERTEX_ANTHROPIC: 'ai-model-vertex-anthropic',
  AI_MODEL_AZURE_OPENAI: 'ai-model-azure-openai',

  /** When enabled, users can pick HTTP tool when configuring a property */
  HTTP_TOOL: 'http-tool',

  /**
   * When enabled, advanced debugging tools will be available
   * through the UI.
   */
  DEV_MODE: 'ui-dev-mode',
  /** When enabled, don't show pricing plans page */
  DISABLE_PRICING_PLANS_PAGE: 'disable-pricing-plans-page',
  /** When enabled, the web search tool should be available */
  WEB_SEARCH_TOOL: 'web-search-tool',

  /**
   * When enabled, adds X-V7-Go-Experimental: true header to all API requests
   */
  EXPERIMENTAL_BACKEND: 'experimental-backend',

  /**  When enabled, Gemini 2.5 Pro will be available as a model option */
  GEMINI_2_5_PRO: 'enable-gemini-2-5-pro',

  /** When enabled, the Hubs section in Knowledge is active */
  HUBS: 'hubs',

  /** Turns on the skip field UI in agent table */
  SKIPPING_FIELDS: 'skipping-fields',

  /** Enables creation of data properties */
  DATA_PROPERTIES: 'data-properties',

  /** When enabled, the case sidebar will show a dot indicator for unread cases */
  CASE_STATUS_DOT: 'case-status-dot',
} as const

export type FeatureFlag = (typeof FeatureFlag)[keyof typeof FeatureFlag]
